import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withTheme from '../styles/withTheme'
import { createUseStyles } from 'react-jss'

import './tab.scss'


const styles = {
	tabBottomPadding: { paddingBottom: props => props.paddingBottom },
	tabHeight: { maxHeight: props => props.maxHeight }
}

const useStyles = createUseStyles(styles, { name: 'Vb' })

/* @TODO:
 * - focus managment
 * - propsTypes
 */

const Tab = forwardRef(function Tab(props, ref) {
	const {
		children,
		className,
		component,
		disabled = false,
		disableFocusRipple = false,
		// eslint-disable-next-line react/prop-types
		fullWidth,
		icon,
		label,
		maxHeight,
		onChange,
		onClick,
		onFocus,
		paddingBottom,
		// eslint-disable-next-line react/prop-types
		selected,
		// eslint-disable-next-line react/prop-types
		selectionFollowsFocus,
		// eslint-disable-next-line react/prop-types
		textColor = 'inherit',
		value,
		wrapped = false,
		...other
	} = props

	const TabComponent = component ? component : 'button'
	const TabContent = component ? 'div' : 'span'

	const classes = useStyles(props)

	const handleFocus = (event) => {
		if (selectionFollowsFocus && !selected && onChange) {
			onChange(event, value)
		}

		if (onFocus) {
			onFocus(event)
		}
	}

	return (
		<TabComponent
			className={clsx(
				'Vb-tab',
				selected && 'Vb-tab--selected',
				fullWidth && 'Vb-tab--full-width',
				disabled && 'Vb-tab--disabled',
				paddingBottom && classes.tabBottomPadding,
				maxHeight && classes.tabHeight,
				className
			)}
			ref={ref}
			role="tab"
			aria-selected={selected}
			disabled={disabled}
			onClick={!disabled ? onClick : null}
			onFocus={handleFocus}
			tabIndex={selected ? 0 : -1}
			value={value}
			{...other}
		>
			<TabContent className="Vb-tab__content">{children}</TabContent>
		</TabComponent>
	)
})

export default withTheme('Vb-tab')(Tab)

Tab.propTypes = {
	// ----------------------------- Warning --------------------------------
	// | These PropTypes are generated from the TypeScript type definitions |
	// |     To update them edit the d.ts file and run "yarn proptypes"     |
	// ----------------------------------------------------------------------
	/**
	 * This prop isn't supported.
	 * Use the `component` prop if you need to change the children structure.
	 */
	children: PropTypes.node,
	/**
	 * Override or extend the styles applied to the component.
	 */
	classes: PropTypes.object,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * If `true`, the component is disabled.
	 * @default false
	 */
	disabled: PropTypes.bool,
	/**
	 * If `true`, the  keyboard focus ripple is disabled.
	 * @default false
	 */
	disableFocusRipple: PropTypes.bool,
	/**
	 * If `true`, the ripple effect is disabled.
	 *
	 * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	 * to highlight the element by applying separate styles with the `.Mui-focusedVisible` class.
	 * @default false
	 */
	disableRipple: PropTypes.bool,
	/**
	 * The icon to display.
	 */
	icon: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
	/**
	 * The label element.
	 */
	label: PropTypes.node,
	/**
	 * When true, it sets the max-height of the tab to 48px
	 */
	limitHeight: PropTypes.bool,
	/**
	 * @ignore
	 */
	onChange: PropTypes.func,
	/**
	 * @ignore
	 */
	onClick: PropTypes.func,
	/**
	 * @ignore
	 */
	onFocus: PropTypes.func,
	/**
	 * Overrides the 12px default padding-bottom of the tab
	 */
	paddingBottom: PropTypes.number,
	/**
	 * The system prop that allows defining system overrides as well as additional CSS styles.
	 */
	sx: PropTypes.object,
	/**
	 * You can provide your own value. Otherwise, we fallback to the child position index.
	 */
	value: PropTypes.any,
	/**
	 * Tab labels appear in a single row.
	 * They can use a second line if needed.
	 * @default false
	 */
	wrapped: PropTypes.bool
}
